import {
  ensure,
  wrapErrors,
  asAString,
  asAInteger,
  beBetween,
  itsProperty,
  ensureProperties,
  anyOf,
  validateNotOverlapingOf,
  notEmpty,
} from "../Common/composition";
import SelectInput from "common/SelectInput";

const validatePriority = wrapErrors(
  (error) => `Priority ${error}`,
  ensure(asAInteger(beBetween(-9999, 9999)))
);
 
const validateCodePoint = wrapErrors(
  (error) => `Code Point ${error}`,
  ensure(
    notEmpty,
    asAInteger(beBetween(0, 63))
  )
);

const directionOptions = [
  { label: "uplink or downlink", value: "any" },
  { label: "downlink", value: "downlink" },
  { label: "uplink", value: "uplink" },
];

const anyMeansBoth = input => input.replace('"any"', '"uplink or downlink"');
const validateDirection = wrapErrors(
  (error) => `Direction ${anyMeansBoth(error)}`,
  ensure(asAString(anyOf(...directionOptions.map(option => option.value))))
);

const describe = ({ codePoint, direction }) =>
  `${codePoint} code point on direction "${direction}"`

const compare = (one, another) =>
  one.codePoint === another.codePoint && one.direction === another.direction;

const validateCodePointsEntry = wrapErrors(
  (error) => `Code point entry ${anyMeansBoth(error)}`,
  ensure(
    ensureProperties(
      itsProperty("codePoint", validateCodePoint),
      itsProperty("direction", validateDirection)
    ),
    validateNotOverlapingOf(compare, describe)
  )
)

const assertCodeAndDirection = ({ codePoint, direction, cli="cp" }) =>
    direction === 'any'
      ? [`${cli} ${codePoint}`]
      : [`${cli} ${codePoint} ${direction}`]

const assertCodepointEntry = ({ added = [], keeped = [], updated = [] }) => [
  ...[...added, ...keeped, ...updated].map(assertCodeAndDirection),
];

const dscpComposition = {
  cliType: "dscp",
  typeLabel: "DSCP",
  viewURL: "viewDSCPProfileConfig",
  redeclareToUpdate: true,
  profileFn: (row)=>{
    return {
      stored: true, 
      pristine: true,
      name: row["NAME"],
      codePoints: row["CODEPOINT"].map(item=> {
        return {
          codePoint: item["CODEPOINT"],  
        };
      }),
      priority: row["PRIORITY"]
    }
  },
  fields: [
    { name: "name", label: "Profile name", type: "text", canUpdate: true, resName: "NAME", numeric: false },
    {
      name: "codePoints",
      cliName: "cp",
      label: "code points",
      labelSingle: "code point",
      importable: false,
      type: "many",
      validate: validateCodePointsEntry,
      canBeEmpty: false,
      resName: "CODEPOINT",
      numeric: false,
      cliExpressAs: assertCodepointEntry /* profile is cleared before */,
      fields: [
        {
          name: "codePoint",
          label: "Code Point",
          labelClassName: "nowrap",
          type: "numer",
          icon: "label_outline",
          colClassName: "text-left",
          validate: validateCodePoint,
          resName: "CODEPOINT",
          numeric: false,
        },
        {
          name: "direction",
          label: "Direction",
          type: "select",
          InputComponent: SelectInput,
          options: directionOptions,
          editionClassName: "full-width",
          defaultValue: "any",
          icon: "import_export",
          validate: validateDirection,
          resName: "DIRECTION",
          numeric: false,
        },
      ],
    },
    {
      name: "priority",
      label: "Priority",
      type: "number",
      defaultValue: "9999",
      icon: "label_outline",
      idx: 3, // Fixes after "many" grouping issue
      validate: validatePriority,
      min: -9999,
      max: 9999,
      resName: "PRIORITY",
      numeric: true,
    },
  ],
};

export default dscpComposition;
  
